import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { CardSetTransformationService, CoreService, DataService, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AppDataService } from 'src/app/services/app-data.service';
import { take, finalize } from 'rxjs';
import { POP_UP_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-vptas-lga',
  templateUrl: './vptas-lga.component.html',
  styleUrl: './vptas-lga.component.scss'
})
export class VptasLgaComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.vptasLga;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  response;
  private isPendingChangePreview: boolean;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {
      displayBtnSave: () => !this.isPendingChangePreview
    };
    // Visibility conditions
    this.coreService.conditionFunctions = {
      alwaysReadOnly: () => true,
      isPendingChangePreview: () => this.isPendingChangePreview
    }

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasLgaConfigAndResponse;
        this.id = id;
      }
    });


  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event: any): void {
    this.response = $event;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.exit();
  }

  dialogButton_saveSuccessful_Clicked(event: any): void {
    this.exit(true);
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.navigate([ROUTE_CONSTANTS.VptasLga.list], ignoreUnsavedChanges);
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.vptasLga.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.id = data.id;
            this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );
  }

}
